// src/directives/scroll-lock.directive.ts
import { ScrollLockService } from "#services/shared/scroll-lock.service";
import {
  Directive,
  Input,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
} from "@angular/core";

@Directive({
  selector: "[appScrollLock]",
  standalone: false,
})
export class ScrollLockDirective implements OnInit, OnDestroy {
  @Input("blockScroll") blockScroll: boolean = false;
  @Input() visible: boolean = false;
  private previousVisible = false;

  constructor(
    private el: ElementRef,
    private scrollLockService: ScrollLockService
  ) {}

  ngOnInit(): void {
    // Initial check
    if (this.blockScroll && this.visible) {
      this.scrollLockService.lock();
      this.previousVisible = true;
    }
  }

  @HostListener("visibleChange", ["$event"])
  onVisibleChange(visible: boolean): void {
    if (this.blockScroll) {
      if (visible && !this.previousVisible) {
        this.scrollLockService.lock();
      } else if (!visible && this.previousVisible) {
        this.scrollLockService.unlock();
      }
      this.previousVisible = visible;
    }
  }

  ngOnDestroy(): void {
    // Clean up if component is destroyed while visible
    if (this.blockScroll && this.visible) {
      this.scrollLockService.unlock();
    }
  }
}
